import { useEffect, useRef } from 'react';

const useOutClick = (onClickOut) => {
    const elementRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (elementRef.current && !elementRef.current.contains(event.target)) {
                if (onClickOut) onClickOut()
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [elementRef]);

    return elementRef;
}

export default useOutClick;